<!-- 快手 计划 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_ndex == 0" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						总计
					</div>
					<!-- <div v-else-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						
					</div> -->
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) < 0 && z_table_control.indexOf(z_tem.type) < 0 && n_table_control.indexOf(z_tem.type) < 0" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] | tableToFixed}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
				
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && n_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]}}
				</div>
			</template>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="color: #2F88FF;">
					{{item[rableTitle[0].type]}}
				</div>

				<!-- <div  class="table-td-cell" style="display: flex;align-items: center;justify-content: space-between;"
				:style="{'width':rableTitle[1].width + 'px'}"> -->
					<!-- <a-switch size="small" :checked="item.status_checked" default-checked @change="onStatusCheckbox($event,item)"  checked-children="启用" un-checked-children="暂停"/> -->
					<!-- <div @click="zhOperation(8,item)" class='cz-cell'>小时数据</div> -->
					<!-- <div @click="zhOperation(9,item)" class='cz-cell'>天数据</div> -->
					
				<!-- </div> -->
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) < 0 && n_table_control.indexOf(z_tem.type) < 0 && f_table_control.indexOf(z_tem.type) < 0" 
				class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | tableToFixed}}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'status'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | statusFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'put_status'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | putStatusFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'study_status'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | studyStatusFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'bid_type'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<!-- 如果bid_type = ocpc，展示cpa_bid的取值。如果bid_type 不等于ocpc，展示bid字段的值。 -->
					<template v-if="item[z_tem.type] == 6 || item[z_tem.type] == 10 || item[z_tem.type] == 20">
						<template v-if="item.cpa_bid">
							{{item.cpa_bid/1000}}
						</template>
						<template v-else>{{0}}</template>
					</template>
					<template v-else>
						<template v-if="item.cpa_bid">
							{{item.bid/1000}}
						</template>
						<template v-else>{{0}}</template>
					</template>
					<div style="font-size:12px;color: #ccc;">{{item[z_tem.type] | bidTypeFilters}}</div>
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && n_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'report_config'" 
				 @click="setPlanHc(item)" class="table-td-cell"  style="cursor: pointer;color: rgb(98, 168, 234);"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<!-- 计划回传比例 -->
					<div v-if="item.report_config" style="display: flex;flex-wrap: wrap;align-items: center;">
						<div v-if="item.report_config.status == 1" style="margin-right: 7px;flex-shrink: 0;">
							<a-tag color="green">已启用</a-tag>
						</div>
						<div v-else style="flex-shrink: 0;margin-right: 7px;">
							<a-tag>未启用</a-tag>
						</div>
						
						<template v-if="item.report_config.report_per_type == 1">
							<div>
								固定序列
							</div>
							<div style="width: 100%;height: 5px;"></div>
							<div>回传比例：{{item.report_config.report_per}}</div>
							<div style="margin-left: 10px;">回传最低金额：{{item.report_config.report_money_limit || 0}}</div>
						</template>
						<template v-else-if="item.report_config.report_per_type == 2">
							<div>自定义序列</div>
						</template>
					</div>
					<div v-else>
						未设置
					</div>
				</div>
				<!-- 落地页回传比例 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'report_per'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if='item.link'>{{item.link.report_per}}</div>
				</div>
				<!-- 落地页ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'link_id'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.link_id">{{item.link_id}}</div>
				</div>
				<!-- 投手 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'admin_list'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.admin_list.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;">
						<div v-for="(item,index) in item.admin_list" :key="index" style="margin: 0 10px 5px 0;">
							{{item.admin_name}}
						</div>
					</div>
				</div>
			</template>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'KSjhTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','indeterminate','checkAll','table_null_width'],
	data(){
		return {
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 0,
			
			// 用于总计的不显示控制
			z_table_control: ['put_status','status','study_status','bid_type','bid','cpa_bid','report_config','report_per','link_id','advertiser_id','campaign_id','unit_id','create_time','admin_list'],
			// 表格项要进行百分比展示的
			c_table_control: ['eff_roi','eff_roi_first','photo_click_ratio','action_ratio','play_3s_ratio'],
			// 表格内容项，不要处理可以直接展示的
			n_table_control: ['bid','cpa_bid','advertiser_id','campaign_id','create_time','cpa_bid','plan_id','group_name','adv_name','unit_id','show','photo_click','aclick','bclick','activation','event_pay_first_day','user_click','eff_total_order_cnt','eff_total_pay_user_cnt','eff_report_pay_user_cnt'],
			// 表格项会有单独处理的项，比如要过滤的，要进行额外处理、展示的
			f_table_control: ['put_status','status','study_status','bid_type','link_id','report_config','report_per','admin_list'],
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		
		// 操作
		operation(e,item){
			console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				// this.$router.push({name: 'JLcy_',params: {jump_id: item.plan_id}})
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			
		},
		// 表格内的操作项
		zhOperation(e,item){
			// console.log(item);
			item.popover_clicked = false
			if(e == 1){ // 同步账户信息
				
				this.$emit('sync-zhxx-click', item)
			}
			else if(e == 8){ // 小时数据
				this.$emit('td-handle', 8, item)
			}
			else if(e == 9){ // 天数据
				this.$emit('td-handle', 9, item)
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 操作项的开关
		onStatusCheckbox(e,item){ // 启用或暂停
			// console.log(e,item);
			this.$emit('status-Checkbox', e, item)
		},
		
		// 设置计划回传比例
		setPlanHc(item){
			// console.log(item);
			this.$emit('set-Plan-Hcbl', item)
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		},
		statusFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value == -1){
				vvv = "不限"
			}
			else if(value == 1){
				vvv = "计划已暂停"
			}
			else if(value == 3){
				vvv = "计划超预算"
			}
			else if(value == 6){
				vvv = "余额不足"
			}
			else if(value == 11){
				vvv = "审核中"
			}
			else if(value == 12){
				vvv = "审核未通过"
			}
			else if(value == 14){
				vvv = "已结束"
			}
			else if(value == 15){
				vvv = "已暂停"
			}
			else if(value == 17){
				vvv = "组超预算"
			}
			else if(value == 19){
				vvv = "未达投放时间"
			}
			else if(value == 20){
				vvv = "有效"
			}
			else if(value == 22){
				vvv = "不在投放时段"
			}
			else {
				vvv = "其他"
			}
			return vvv
		},
		putStatusFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value == 1){
				vvv = "投放中"
			}
			else if(value == 2){
				vvv = "暂停"
			}
			else if(value == 3){
				vvv = "删除"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		studyStatusFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value == 1){
				vvv = "学习中"
			}
			else if(value == 2){
				vvv = "学习成功"
			}
			else if(value == 3){
				vvv = "学习失败"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		bidTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value == 1){
				vvv = "CPM"
			}
			else if(value == 2){
				vvv = "CPC"
			}
			else if(value == 6){
				vvv = "OCPC(使用 OCPC 代表 OCPX)"
			}
			else if(value == 10){
				vvv = "OCPM"
			}
			else if(value == 20){
				vvv = "eCPC"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
	min-width: 85px;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

.cz-cell {
	color: #62a8ea;
	cursor: pointer;
	/* margin-right: 7px; */
	/* margin-top: 5px; */
}
.cz-cell:hover{
	color: rgb(47, 136, 255);
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>